export default {
    name: 'MessageBox',
    props: ['btns'],
    emits: ['confirm', 'hidden'],
    data () {
        return {
            data: null,
            title: '',
            message: '',
            size: '',
            curbtns: this.btns,
            textBtnCancel: null,
            textBtnOk: null
        }
    },
    computed: {
        defaultBtns () {
            return ['confirm', 'cancel'];
        }
    },
    methods: {
        show (
            data,
            title,
            message,
            textBtnCancel = this.$t('general.cancel'),
            textBtnOk = this.$t('general.ok'),
            size = '',
            btns = null
        ) {
            this.data = data;
            this.title = title;
            this.message = message;
            this.size = size;
            this.textBtnCancel = textBtnCancel;
            this.textBtnOk = textBtnOk;
            if (btns !== null) {
                this.curbtns = btns;
            }
            this.$refs['modal-window'].show();
        },
        displayBtn (btn) {
            if (this.curbtns) {
                if (this.curbtns.includes(btn)) {
                    return true;
                }
            } else if (this.defaultBtns.includes(btn)) {
                return true;
            }
            return false;
        },
        confirm () {
            this.$emit('confirm', this.data);
            this.$refs['modal-window'].hide();
        },
        close () {
            this.$refs['modal-window'].hide();
        },
        modalClosed () {
            this.$emit('hidden', true);
        }
    }
}
